import { cva } from 'class-variance-authority';

export const categoriesVariants = cva('categories', {
    variants: {
        variant: {
            default: 'categories--default',
            carousel: 'categories--carousel',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
